import { render } from "./historyButtonRenderer.vue?vue&type=template&id=0af54d8e"
import script from "./historyButtonRenderer.vue?vue&type=script&lang=js"
export * from "./historyButtonRenderer.vue?vue&type=script&lang=js"

import "./historyButtonRenderer.vue?vue&type=style&index=0&id=0af54d8e&lang=css"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__